import React from "react";

const YoutubeIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"><path d="M17 0a17 17 0 1 1-17 17 17 17 0 0 1 17-17zm2.4 17.222l-3.754 2.059c-.163.088-.309-.03-.309-.215v-4.226c0-.188.151-.306.315-.213l3.779 2.167a.246.246 0 0 1-.031.428zm5.939-2.428a3.629 3.629 0 0 0-3.629-3.629h-9.416a3.629 3.629 0 0 0-3.629 3.629v4.411a3.629 3.629 0 0 0 3.629 3.629h9.413a3.629 3.629 0 0 0 3.628-3.629z" fill={props.fill} /></svg>
    )
}

export default YoutubeIcon;
